import { Navigate } from 'react-router-dom';

const VpnIndexRedirect = () => {
  return <Navigate to="/vpn/ike-policies" replace />;
};

export default VpnIndexRedirect;


